

























import { SfButton, SfInput } from '@storefront-ui/vue';
import {
    computed,
    ref,
    defineComponent,
} from '@nuxtjs/composition-api';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import { useCart } from '~/modules/checkout/composables/useCart';
import { cartCouponApplyLink } from '~/helpers/trackings/24orepro/cart';
import { useCartView } from '~/composables';

export default defineComponent({
    name: 'CouponCode',
    components: {
        SfButton,
        SfInput,
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    setup() {
        const {
            cart, applyCoupon, removeCoupon, error, loading
        } = useCart();

        const { totals } = useCartView();

        const couponCodeUserInput = ref();
        const couponCodeAppliedToCart = computed(() => cartGetters.getAppliedCoupon(cart.value)?.code);
        const isCouponCodeApplied = computed(() => couponCodeAppliedToCart.value !== undefined);
        const hasAnyError = computed(() => Object.values(error.value).some((value) => value !== null));
        const discounts = computed(() => cartGetters.getDiscounts(cart?.value));

        return {
            cartId: cart.value?.id,
            couponCodeUserInput,
            couponCodeAppliedToCart,
            isCouponCodeApplied,
            hasAnyError,
            loading,
            discounts,
            cart,
            totals,
            removeCoupon,
            applyCoupon
        };
    },
    
    methods:{
        async applyOrRemoveCoupon () {
            const $t = this;
            const couponCodeEl = (this.$refs.couponCodeUserInput as HTMLInputElement)
            const couponCode = couponCodeEl.value
            const operationPromise = this.isCouponCodeApplied
                ? this.removeCoupon({}) /** We don't want to remove coupon, but it's ready if the client changes his mind */
                : this.applyCoupon({ couponCode });
            await operationPromise;
            setTimeout(()=>{
                if(this.isCouponCodeApplied){
                    // @ts-ignore
                    //document.querySelector('.discount-code').value = couponCode;
                    cartCouponApplyLink(couponCode, this.discounts, this.totals);
                    document.querySelector('.discount-message.valid').classList.remove('hidden')
                }
            },1000)
        }
    }
});
